/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlOrganizationMatch } from './ControlOrganizationMatch';
import {
    ControlOrganizationMatchFromJSON,
    ControlOrganizationMatchFromJSONTyped,
    ControlOrganizationMatchToJSON,
} from './ControlOrganizationMatch';

/**
 * 
 * @export
 * @interface ControlSearchOrganizationsResponse
 */
export interface ControlSearchOrganizationsResponse {
    /**
     * 
     * @type {Array<ControlOrganizationMatch>}
     * @memberof ControlSearchOrganizationsResponse
     */
    matches: Array<ControlOrganizationMatch>;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchOrganizationsResponse
     */
    id: string;
}

/**
 * Check if a given object implements the ControlSearchOrganizationsResponse interface.
 */
export function instanceOfControlSearchOrganizationsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "matches" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ControlSearchOrganizationsResponseFromJSON(json: any): ControlSearchOrganizationsResponse {
    return ControlSearchOrganizationsResponseFromJSONTyped(json, false);
}

export function ControlSearchOrganizationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSearchOrganizationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'matches': ((json['matches'] as Array<any>).map(ControlOrganizationMatchFromJSON)),
        'id': json['id'],
    };
}

export function ControlSearchOrganizationsResponseToJSON(value?: ControlSearchOrganizationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'matches': ((value.matches as Array<any>).map(ControlOrganizationMatchToJSON)),
        'id': value.id,
    };
}

